import {ChatMessage, MessageType, Role, WidgetPosition} from "./chatbotSlice";

export const generateTemplatedMessage = (message: string): ChatMessage => {
    return {
        isBot: true,
        saved: false,
        role: Role.ASSISTANT,
        message: {
            rowMessage: JSON.stringify({message_type: MessageType.TEXT, message}),
            message: message,
            messageType: MessageType.TEXT,
        },
        time: Date.now()
    }
}

export const calcTimeDiff = (value: number) => {
    const now = new Date();
    const time = new Date(value);

    let diff = now.getTime() - time.getTime();

    if (Math.round(diff / 1000) < 10) {
        return "Just Now";
    } else {
        return time.toLocaleTimeString();
    }
};

export const isDevEnv = (profile?: string) => {
    return profile && profile.toUpperCase() == "DEV";
}

export const handleLinkInChatClick = (e: any, href?: string, websiteLocation?: string, isNewWindow?: boolean) => {
    if (websiteLocation) {
        e.preventDefault();
        window.parent.postMessage(
            {
                type: 'open-link',
                href: href,
                inNew: isNewWindow,
            },
            websiteLocation
        );
    }
}

export const sendChangeWidgetPositionEvent = (widgetPosition: WidgetPosition, horizontalOffsetPx: number, verticalOffsetPx: number, websiteLocation: string) => {
    if (websiteLocation) {
        window.parent.postMessage(
            {
                type: "change-widget-position",
                ...(widgetPosition.includes("BOTTOM")
                    ? { bottom: verticalOffsetPx }
                    : { top: verticalOffsetPx }),
                ...(widgetPosition.includes("RIGHT")
                    ? { right: horizontalOffsetPx }
                    : { left: horizontalOffsetPx }),
            },
            websiteLocation
        )
    }
}
